module.exports = __webpack_public_path__ + "img/video-cover.cc420759.png";